<template>
  <modal-template
    ref="modal"
    size="lg"
    title="Comentários do orçamento"
    type-modal="comments_modal"
  >
    <div class="modal-content__main">
      <ul class="comments">
        <li v-for="(comment, index) in quotation.comments" :key="index" class="blog-comments__item d-flex p-3">
          <!-- Avatar -->
          <div class="blog-comments mr-3">
            <img v-if="comment.user.image && comment.user.image.url" :src="comment.user.image.url" :alt="comment.user.name" class="user-avatar rounded-circle mr-2">
            <img v-else class="user-avatar rounded-circle mr-2" src="@/assets/images/avatars/enhanced-buzz.jpeg" :alt="comment.user.name">
          </div>

          <!-- Content -->
          <div class="blog-comments__content ql-snow">

            <!-- Content - Title -->
            <div class="blog-comments__meta text-muted">
              <span class="text-secondary">{{ comment.user.name }}</span>
              <span class="text-muted"> – {{ comment.created_at }}</span>
              <span class="text-muted ml-2" v-if="comment.edited"> <small>Editado</small></span>
              <d-button size="sm" class="btn-outline-info ml-2 py-1" v-if="userId === comment.user.id" @click="editComment(comment)">Editar</d-button>
            </div>

            <!-- Content - Body -->
            <div class="m-0 my-1 mb-2">
              <div class="ql-editor p-0" v-html="comment.comment"></div>
            </div>

          </div>
        </li>
        <li v-if="quotation.comments && quotation.comments.length == 0" class="no-content">Ainda não há nenhum comentário</li>
      </ul>
    </div>


    <d-form slot="actions" class="modal-content__control">
      <d-form-row>
        <!-- Message -->
        <d-col class="form-group">
          <label>Comentário</label>
          <editor ref="recibo" :model.sync="model.comment"/>
        </d-col>
        <d-col cols="auto" class="form-group">
          <d-button
            type="button"
            @click="send()"
            class="btn btn-sm btn-primary"
          >Enviar</d-button>
        </d-col>
      </d-form-row>
    </d-form>
  </modal-template>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';

import { mapActions } from 'vuex';
import Editor from '_shared/Editor.vue';
import Events from '_utils/events';
import ModalTemplate from '_shared/Modal.vue';
import QuotationService from '_services/rest/modules/quotation';
import { MODEL, _LOAD_COMMENTS_ } from '../QuotationModel';

export default {
  name: 'send-email',
  data() {
    return {
      loading: false,
      model: {
        id: null,
        comment: '',
      },
      quotation: { ...MODEL },
    };
  },
  components: {
    Editor,
    ModalTemplate,
  },
  computed: {
    userId() {
      const { user } = this.$store.state.user;
      return user.id;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    editComment(comment) {
      this.model = comment;
    },
    send() {
      const params = { comment: this.model, quotation_id: this.quotation.id };
      QuotationService.sendComment(params)
        .then(() => {
          this.setToggle({ type: 'comments_modal', bool: false });
          this.activeAlert({ message: 'Orçamento enviado com sucesso', theme: 'success' });
          Events.$emit('update:pagination', false);
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }));
    },
  },
  mounted() {
    Events.$on(_LOAD_COMMENTS_, quotation => {
      this.quotation = quotation;
    });
  },
};
</script>

<style lang="scss" scoped>
.modal {
  &-body {
    padding: 15px;
    .modal-content__main {
      background: #f1f1f1;
      border: 1px solid #dfe1e3;
      width: 100%;
      min-height: 100%;
      .blog-comments__content {
        width: 100%;
        background: #ffffff;
        border: 1px solid #dfe1e3;
        border-radius: 4px;
        padding: 10px;
      }
      // User avatar
      .user-avatar {
        max-width: 3.125rem;
        height: 3.125rem;
      }
      .comments {
        list-style: none;
        padding: 0;
        margin-bottom: 0;
        .no-content {
          padding: 20px;
        }
      }
    }
  }
  &-footer {
    flex-direction: column;
  }
  &-content__control {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    .form-row {
      width: 100%;
      align-items: center;
    }
  }
}
</style>
